import { createContext, useContext, useState } from "react";

const PlatformFeedbackContext = createContext(null);

export function PlatformFeedbackProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [product, setProduct] = useState(null);
  const [eventType, setEventType] = useState(null);

  const openFeedback = ({ product, eventType }) => {
    if (typeof product !== "undefined") setProduct(product);
    if (typeof eventType !== "undefined") setEventType(eventType);
    setOpen(true);
  };

  const closeFeedback = () => {
    setOpen(false);
    setProduct(null);
    setEventType(null);
  };

  const value = {
    open,
    product,
    eventType,
    openFeedback,
    closeFeedback,
    setOpen,
    setProduct,
    setEventType,
  };

  return <PlatformFeedbackContext.Provider value={value}>{children}</PlatformFeedbackContext.Provider>;
}

export function usePlatformFeedback() {
  const ctx = useContext(PlatformFeedbackContext);
  if (!ctx) {
    throw new Error("usePlatformFeedback must be used within a PlatformFeedbackProvider");
  }
  return ctx;
}
